import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import ProposalSearchModal from './ProposalSearchModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import { ProposalResponse } from 'services/proposal';
import { FinContractResponse } from 'services/fincontract';

export type ProposalSelectedType = {
  ctrid?: number;
  propreference?: string;
  clientname?: string;
  ctexternalpropref?: string;
  values?: ProposalResponse | FinContractResponse;
};

export type ProposalSelectProps = {
  prcode?: string;
  onChange?: any;
  onSelected?: (value: ProposalSelectedType) => void;
  value?: ProposalSelectedType;
  phase?: string;
  PropOrProd?: string;
  hideFilters?: boolean;
  hideAction?: boolean;
  onlyctrid?: boolean;
  clear?: boolean;
  display?: boolean;
  style?: any;
  isCreate?: boolean;
  valueToDisplay?: ProposalSelectedType;
  objectName?: string;
  flagPropWithCtreference?: boolean;
};

const ProposalSelect = ({
  onChange = noop,
  onSelected,
  value,
  phase,
  prcode,
  clear,
  PropOrProd,
  hideFilters,
  hideAction,
  onlyctrid,
  display,
  style,
  isCreate,
  valueToDisplay,
  objectName,
  flagPropWithCtreference,
}: ProposalSelectProps) => {

  const [Params, setParams] = useState<ProposalSelectedType>({
    ctrid: value?.ctrid,
    propreference: value?.propreference,
    clientname: value?.clientname,
    ctexternalpropref: value?.ctexternalpropref,
  });
  const { visible, close, open } = useModalState(false);
  const [onClear, setonClear] = useState(false);
  const [tpModal, setTpModal] = useState(false);

  const handleSelect = (item: any) => {
    onlyctrid ? onChange(item.ctrid) : onChange(item);

    if (PropOrProd === 'PROD' || flagPropWithCtreference) {
      setParams({
        propreference: item?.ctreference,
        clientname: item.clientname,
        ctrid: item?.ctrid,
        ctexternalpropref: item?.ctexternalpropref,
      });
      if (onSelected)
        onSelected({
          propreference: item?.ctreference,
          clientname: item.clientname,
          ctrid: item?.ctrid,
          ctexternalpropref: item?.ctexternalpropref,
          values: item
        });
    } else {
      if (onSelected)
        onSelected({
          propreference: item?.propreference,
          clientname: item.clientname,
          ctrid: item?.ctrid,
          ctexternalpropref: item?.ctexternalpropref,
          values: item
        });
      setParams({
        propreference: item?.propreference,
        clientname: item.clientname,
        ctrid: item?.ctrid,
        ctexternalpropref: item?.ctexternalpropref,
      });
    }
    setonClear(true);
    close();
  };


  useEffect(() => {
    setonClear(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    value = undefined;
    setParams({
      propreference: undefined,
      clientname: undefined,
      ctrid: undefined,
      ctexternalpropref: undefined,
    });
  }, [clear]);
  const [visibleModal, setvisibleModal] = useState(false);

  const formatDisplayValue = (item: ProposalSelectedType | null | undefined): string => {
    if (!item?.ctrid) return '';
    
    const hasExternalRef = !!item.ctexternalpropref;
    const externalRefPart = hasExternalRef 
      ? `${item.ctexternalpropref} - ${item.ctrid}` 
      : `${item.ctrid}`;
    const clientNamePart = item.clientname ?? item.ctrid ?? '';
    
    return `${externalRefPart}  -  ${clientNamePart}`;
  };

  return (
    <>
      <div style={style}>
        {display ? (
          <Typography.Link
            onClick={() => {
              setTpModal(true);
              setvisibleModal(true);
            }}
            title="Open details"
            ellipsis
          >
            {valueToDisplay?.ctrid
              ? formatDisplayValue(valueToDisplay)
              : onClear && !value?.ctrid
              ? Params?.ctrid && value !== isNil
                ? formatDisplayValue(Params)
                : phase === undefined
                ? 'Select a Proposal'
                : 'Select a Contract'
              : value?.ctrid && value !== isNil
              ? formatDisplayValue(value)
              : phase === undefined
              ? 'Select a Proposal'
              : 'Select a Contract'}
          </Typography.Link>
        ) : (
          <AppSearchInput
            onSearch={() => {
              open();
              localStorage.removeItem('searchParams');
              localStorage.removeItem('searchParams_components');
            }}
            value={
              <Typography.Link
                onClick={() => {
                  setTpModal(true);
                  setvisibleModal(true);
                }}
                title="Open details"
                ellipsis
              >
                {onlyctrid && !value?.ctrid
                  ? Params?.ctrid && value !== isNil && value !== undefined
                    ? formatDisplayValue(Params)
                    : isCreate
                    ? 'Select a Proposal'
                    : 'Select a Contract'
                  : value?.ctrid && value !== isNil
                  ? formatDisplayValue(value)
                  : isCreate
                  ? 'Select a Proposal'
                  : 'Select a Contract'}
              </Typography.Link>
            }
          />
        )}
      </div>
      <ProposalSearchModal
        prcode={prcode}
        phase={phase}
        visible={visible}
        onCancel={close}
        setProposal={handleSelect}
        PropOrProd={PropOrProd}
        hideAction={hideAction}
        clientname={objectName}
        flagPropWithCtreference={flagPropWithCtreference}
      />
      {value?.ctrid ? (
        <ProposalModal
          onCancel={() => {
            setvisibleModal(false);
          }}
          visible={visibleModal}
          onSuccess={() => setvisibleModal(true)}
          title=""
          iscreate={false}
          ctrid={onlyctrid ? Number(value) ?? 0 : value?.ctrid ?? 0}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ProposalSelect;
